import React, { useState } from 'react'
import deLocale from 'date-fns/locale/es'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
import { ThemeProvider } from '@material-ui/styles'
import { Calendar } from '@ripley-ui/icon/'
import defaultMaterialTheme from './style'
import IconButton from '../IconButton'
import Grid from '../Grid/Grid'
import TextField from '../TextField'
import { format } from 'date-fns'

const Datepicker: React.FC<any> = ({ ...props }) => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [textFieldValue, setTextFieldValue] = useState('')
  const handleDateChange = (date: Date) => {
    setSelectedDate(date)
    setTextFieldValue(format(new Date(date), 'dd/MM/yyyy'))
  }
  const renderInput = ({ ...props }) => {
    return (
      <TextField
        variant="outlined"
        placeholder="Seleccionar Fecha"
        label="Seleccionar Fecha"
        InputProps={{
          endAdornment: (
            <IconButton onClick={props.onClick}>
              <Calendar />
            </IconButton>
          ),
        }}
        value={textFieldValue}
      />
    )
  }
  return (
    <React.Fragment>
      <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
        <Grid container justify="space-around">
          <ThemeProvider theme={defaultMaterialTheme}>
            <DatePicker
              disableToolbar
              variant="inline"
              margin="normal"
              id="date-picker-inline"
              format="dd/MM/yyyy"
              value={selectedDate}
              onChange={handleDateChange}
              disableFuture={props.disableFuture}
              disabled={props.disabled}
              TextFieldComponent={renderInput}
            />
          </ThemeProvider>
        </Grid>
      </MuiPickersUtilsProvider>
    </React.Fragment>
  )
}
export default Datepicker
